import { render, staticRenderFns } from "./plant-index.vue?vue&type=template&id=71eb10b9&scoped=true"
import script from "./plant-index.vue?vue&type=script&lang=js"
export * from "./plant-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71eb10b9",
  null
  
)

export default component.exports